// Shared time utilities for business hours
// Dubai closed hours: 04:00–12:00 (local Dubai time)

// Delivery runs from 12:00 until 20:00 Dubai time; after that only
// pickup is offered. Mirrored in server/services/deliveryFee.js, which
// enforces it — keep both in sync.
export const DELIVERY_START_HOUR = 12;
export const DELIVERY_END_HOUR = 20;

const dubaiHour = (now = new Date()) =>
  Number(
    new Intl.DateTimeFormat("en-GB", {
      hour: "numeric",
      hour12: false,
      timeZone: "Asia/Dubai",
    }).format(now)
  );

export function isDeliveryAvailableDubai() {
  try {
    const hour = dubaiHour();
    return hour >= DELIVERY_START_HOUR && hour < DELIVERY_END_HOUR;
  } catch (_) {
    return true;
  }
}

export function isClosedDubai0400To1200() {
  try {
    const now = new Date();
    const hour = Number(
      new Intl.DateTimeFormat("en-GB", {
        hour: "numeric",
        hour12: false,
        timeZone: "Asia/Dubai",
      }).format(now)
    );
    // return hour >= 4 && hour < 12;
    return hour >= 4 && hour < 9;
  } catch (_) {
    return false;
  }
}

